import { qualifyUrls } from "routing/Routes";
const AuditLogRoutes = {
  LIST: "/system/auditlog",
  CONFIGURATION: "/system/auditlog/configuration"
};
const routes = qualifyUrls(AuditLogRoutes);
export default {
  ...routes,
  unqualified: AuditLogRoutes
};
